import React from "react";
import FlexBox from "view/components/Layout/FlexBox";
import {IconButton, Typography} from "@material-ui/core";
import SettingsIcon from "view/images/SettingsIcon";
import {blue} from "@material-ui/core/colors";
import RequiredIcon from "view/components/GridResponseBlock/CustomizeTable/Components/Rows/Cell/RequiredIcon";
import useStyles from "./styles";

type TextInputProps = {
  isRequired: boolean;
  isActive: boolean;
  onClickSettings: () => void;
  onClickMandatory: () => void;
  viewOnly?: boolean;
};

function TextInput({
  isRequired,
  isActive,
  onClickMandatory,
  onClickSettings,
  viewOnly,
}: TextInputProps) {
  const classes = useStyles();
  const shouldDisplayIcon = !viewOnly || isRequired;

  return (
    <>
      <FlexBox
        className={classes.cellInput}
        justifyContent="space-between"
        alignCenter
      >
        <Typography className={classes.cellInputText}>Input</Typography>
        {shouldDisplayIcon && (
          <RequiredIcon
            onClick={onClickMandatory}
            isRequired={isRequired}
            viewOnly={viewOnly}
          />
        )}
      </FlexBox>
      {!viewOnly && (
        <IconButton className={classes.cellButton} onClick={onClickSettings}>
          <SettingsIcon fill={isActive ? blue.A100 : undefined} />
        </IconButton>
      )}
    </>
  );
}

export default TextInput;
